import React, { memo, useContext, useState } from "react";

import { faFilter } from "@fortawesome/pro-light-svg-icons";
import { Checkbox, FormControlLabel, Popover } from "@material-ui/core";
import PropTypes from "prop-types";

import FontAwesomeButton, {
  ButtonIcon,
} from "components/Button/FontAwesomeButton";
import { Row } from "components/Layout";
import { OptionToggler } from "components/OptionToggler";

import { FiltersOptionsLayout } from "./Layout";
import {
  WeighBridgeSaleDispatchContext,
  WeighBridgeSaleStateContext,
} from "./WeighBridgeSaleContext";

const PenningFilterOptions = [
  {
    value: true,
    label: "Penned",
  },
  {
    value: false,
    label: "Not Penned",
  },
];

export function WeighBridgeFiltersComponent(props) {
  const { filters } = props;

  const { updateFilters } = useContext(WeighBridgeSaleDispatchContext);

  const [filtersButtonEl, setFiltersButtonEl] = useState(null);

  const isFiltersVisible = Boolean(filtersButtonEl);

  function onChangePennedFilter(value) {
    updateFilters({ ...filters, penned: value });
  }

  function onChangeExactMatch(event) {
    updateFilters({ ...filters, exactMatch: event.target.checked });
  }

  function toggleFiltersVisible(event) {
    setFiltersButtonEl(isFiltersVisible ? null : event.target);
  }

  function closeFilters() {
    setFiltersButtonEl(null);
  }

  return (
    <Row>
      <FontAwesomeButton
        onClick={toggleFiltersVisible}
        inline
        size={2}
        padding={10}
        data-tour="filter"
      >
        <ButtonIcon icon={faFilter} />
      </FontAwesomeButton>

      <Popover
        open={isFiltersVisible}
        anchorEl={filtersButtonEl}
        onClose={closeFilters}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "center",
          horizontal: "left",
        }}
      >
        <FiltersOptionsLayout>
          <OptionToggler
            name="Sale Lots Visible"
            value={filters.penned}
            onChange={onChangePennedFilter}
            options={PenningFilterOptions}
          />
          <FormControlLabel
            style={{ marginTop: 12, display: "flex" }}
            control={
              <Checkbox
                checked={filters.exactMatch}
                onChange={onChangeExactMatch}
                color="primary"
                size="small"
              />
            }
            label="Exact pen match"
          />
        </FiltersOptionsLayout>
      </Popover>
    </Row>
  );
}

const WeighBridgeFilters = memo(
  WeighBridgeFiltersComponent,
  (a, b) =>
    a.filters.penned === b.filters.penned &&
    a.filters.exactMatch === b.filters.exactMatch,
);
WeighBridgeFilters.propTypes = {
  filters: PropTypes.shape({
    penned: PropTypes.bool.isRequired,
    exactMatch: PropTypes.bool.isRequired,
  }),
};

function StateAdapter() {
  const { filters } = useContext(WeighBridgeSaleStateContext);

  return <WeighBridgeFilters filters={filters} />;
}

export default memo(StateAdapter);
